module.exports = "./img/e1cb2de15006f7a8246727f57ffe7b03.png";